import { GemCertificate } from '../../../../utils/enums/gem-certification.enum';
import { GemClarity } from '../../../../utils/enums/gem-clarity.enum';
import { GemCut } from '../../../../utils/enums/gem-cut.enum';
import { GemFeature, GemFeatureCode } from '../../../../utils/enums/gem-feature.enum';
import { GemOrigin } from '../../../../utils/enums/gem-origin.enum';
import { GemShape } from '../../../../utils/enums/gem-shape.enum';
import { GemSpecies } from '../../../../utils/enums/gem-species.enum';
import { GemTreatment } from '../../../../utils/enums/gem-treatment.enum';
import { GemColor } from '../../../../utils/enums/gem-color.enum';
import { Intensity } from '../../../../utils/enums/intensity.enum';
import { SpecialDescriptor } from '../../../../utils/enums/gem-special-descriptor.enum';
import { GemLocation } from '../../../../utils/enums/gem-location.enum';

const getKeyValueArray = (obj: Object) => Object.values(obj);

export const colorFilters = [
  {
    testId: 'color-filter',
    title: GemFeature.COLOR,
    code: GemFeatureCode.COLOR,
    options: [
      GemColor.Blue,
      GemColor.Green,
      GemColor.Red,
      GemColor.Teal,
      GemColor.Pink,
      GemColor.BiColor,
      GemColor.MultiColor,
      GemColor.Purple,
      GemColor.Yellow,
      GemColor.Violet,
      GemColor.Brown,
      GemColor.Orange,
      GemColor.Grey,
      GemColor.White,
      GemColor.Black,
      GemColor.Other,
    ],
    position: 'left',
  },
  {
    testId: 'color-special-descriptor-filter',
    title: GemFeature.COLOR_SPECIAL_DESCRIPTORS,
    code: GemFeatureCode.COLOR_SPECIAL_DESCRIPTORS,
    options: [
      SpecialDescriptor.RoyalBlue,
      SpecialDescriptor.CornflowerBlue,
      SpecialDescriptor.Blue,
      SpecialDescriptor.VividBlue,
      SpecialDescriptor.Padparadscha,
      SpecialDescriptor.PigeonBloodRed,
      SpecialDescriptor.RoyalRed,
      SpecialDescriptor.VividRed,
      SpecialDescriptor.HotPink,
      SpecialDescriptor.VividPink,
      SpecialDescriptor.CanaryYellow,
      SpecialDescriptor.VividYellow,
      SpecialDescriptor.LavenderViolet,
      SpecialDescriptor.VividViolet,
      SpecialDescriptor.VividPurple,
      SpecialDescriptor.Teal,
      SpecialDescriptor.GoldenOrange,
      SpecialDescriptor.GoldenYellow,
      SpecialDescriptor.Peach,
      SpecialDescriptor.Nil,
    ],
    position: 'right',
  },
  {
    testId: 'secondary-color-filter',
    title: GemFeature.SECONDARY_COLOR,
    code: GemFeatureCode.SECONDARY_COLOR,
    options: [
      GemColor.Blue,
      GemColor.Green,
      GemColor.Red,
      GemColor.Teal,
      GemColor.Pink,
      GemColor.BiColor,
      GemColor.MultiColor,
      GemColor.Purple,
      GemColor.Yellow,
      GemColor.Violet,
      GemColor.Brown,
      GemColor.Orange,
      GemColor.Grey,
      GemColor.White,
      GemColor.Black,
      GemColor.Other,
    ],
    position: 'left',
  },
];

export const leftFilterFields = [
  {
    title: GemFeature.CLARITY,
    code: GemFeatureCode.CLARITY,
    options: [
      GemClarity.EyeClean,
      GemClarity.SlightlyIncluded,
      GemClarity.ModeratelyIncluded,
      GemClarity.VisiblyIncluded,
    ],
    position: 'left',
  },
  {
    title: GemFeature.CUT,
    code: GemFeatureCode.CUT,
    options: [
      GemCut.Cabochon,
      GemCut.Faceted,
      GemCut.BrilliantStep,
      GemCut.Brilliant,
      GemCut.BrilliantFancy,
      GemCut.ModifiedBrilliant,
      GemCut.ModifiedBrilliantFancy,
      GemCut.Fancy,
      GemCut.ModifiedBrilliantStep,
      GemCut.Bufftop,
      GemCut.Princess,
      GemCut.Radiant,
      GemCut.Step,
      GemCut.Fantasy,
      GemCut.Intaglio,
      GemCut.Rose,
      GemCut.Carved,
      GemCut.Cameo,
      GemCut.Checkerboard,
      GemCut.SugarLoafCabochon,
      GemCut.Other,
    ],
    position: 'left',
  },
  {
    title: GemFeature.CERTIFICATE,
    code: GemFeatureCode.CERTIFICATE,
    options: [
      GemCertificate.ICL,
      GemCertificate.GIA,
      GemCertificate.AGL,
      GemCertificate.GRS,
      GemCertificate.CDC,
      GemCertificate.AGS,
      GemCertificate.DSEF,
      GemCertificate.EGL,
      GemCertificate.FGL,
      GemCertificate.GCAL,
      GemCertificate.GGL,
      GemCertificate.HRD,
      GemCertificate.IGI,
      GemCertificate.AIGS,
      GemCertificate.LOTUS,
      GemCertificate.GUBELIN,
      GemCertificate.RGL,
      GemCertificate.TGL,
      GemCertificate.ALGT,
      GemCertificate.Other,
      GemCertificate.AnyCert,
      GemCertificate.Nil,
      GemCertificate.None,
    ],
    position: 'left',
  },
  {
    title: GemFeature.TREATMENT,
    code: GemFeatureCode.TREATMENT,
    options: [
      GemTreatment.None,
      GemTreatment.Heating,
      GemTreatment.HeatingAndPressure,
      GemTreatment.Oiling,
      GemTreatment.Enhancement,
      GemTreatment.Composite,
      GemTreatment.Dyeing,
      GemTreatment.Waxing,
      GemTreatment.Coating,
      GemTreatment.Diffusion,
      GemTreatment.Filling,
      GemTreatment.Imitation,
      GemTreatment.Bleaching,
      GemTreatment.Irradiation,
      GemTreatment.Impregnated,
      GemTreatment.Lasering,
      GemTreatment.Other,
    ],
    position: 'left',
  },
];

export const rightFilterFields = [
  {
    title: GemFeature.SPECIES,
    code: GemFeatureCode.SPECIES,
    options: [
      GemSpecies.Sapphire,
      GemSpecies.Emerald,
      GemSpecies.Ruby,
      GemSpecies.Tourmaline,
      GemSpecies.Tsavorite,
      GemSpecies.Turquoise,
      GemSpecies.Vanadium,
      GemSpecies.Aquamarine,
      GemSpecies.Aventurine,
      GemSpecies.Spinel,
      GemSpecies.Opal,
      GemSpecies.Pearl,
      GemSpecies.Topaz,
      GemSpecies.Garnet,
      GemSpecies.Indigolite,
      GemSpecies.Iolite,
      GemSpecies.Morganite,
      GemSpecies.Onyx,
      GemSpecies.Peridot,
      GemSpecies.Zircon,
      GemSpecies.Amethyst,
      GemSpecies.Kunzite,
      GemSpecies.LapisLazuli,
      GemSpecies.Malachite,
      GemSpecies.Grandidierite,
      GemSpecies.Ametrine,
      GemSpecies.Jade,
      GemSpecies.Citrine,
      GemSpecies.CatsEye,
      GemSpecies.Coral,
      GemSpecies.Moonstone,
      GemSpecies.Sodalite,
      GemSpecies.Quartz,
      GemSpecies.Rubellite,
      GemSpecies.Chrysoberyl,
      GemSpecies.Apatite,
      GemSpecies.Sphene,
      GemSpecies.Heliodor,
      GemSpecies.Prehnite,
      GemSpecies.Spectrolite,
      GemSpecies.Tanzanite,
      GemSpecies.Alexandrite,
      GemSpecies.Beryl,
      GemSpecies.Other,
    ],
    position: 'right',
  },
  {
    title: GemFeature.INTENSITY,
    code: GemFeatureCode.INTENSITY,
    options: [Intensity.Light, Intensity.Medium, Intensity.DeepNill],
    position: 'left',
  },
  {
    title: GemFeature.SHAPE,
    code: GemFeatureCode.SHAPE,
    options: [
      GemShape.Oval,
      GemShape.Round,
      GemShape.Emerald,
      GemShape.Pear,
      GemShape.Octagonal,
      GemShape.Square,
      GemShape.Marquise,
      GemShape.Heart,
      GemShape.Triangular,
      GemShape.Radiant,
      GemShape.Cushion,
      GemShape.Trilliant,
      GemShape.Hexagonal,
      GemShape.Kite,
      GemShape.Other,
    ],
    position: 'right',
  },
];

export const originAndLocationArray = Object.values(GemOrigin).map((origin) => ({
  origin,
  location: origin === GemOrigin.SriLanka ? getKeyValueArray(GemLocation) : [],
}));
export const getLocationArray = (origin: string) => {
  const location = originAndLocationArray.find((item) => item.origin === origin);
  return location ? location.location : [];
};
